module.exports = (__webpack_public_path__ || '') + "static/images/apple-touch-icon-120x120-8de021b35b89f311c9daa8ee64e620df.png";